import { atom } from "jotai";

export type ToastType = {
    message: string
    type?: 'info' | 'success' | 'warning' | 'error'
}

export const toastAtom = atom<ToastType | string | null>(null)